import * as firebase from 'firebase';

var config = {
	apiKey: "AIzaSyCPsEu47H0KRZpywBkNffYvM1shJHfNd8o",
	authDomain: "ling-dev-123.firebaseapp.com",
	databaseURL: "https://ling-dev-123.firebaseio.com",
	projectId: "ling-dev-123",
	storageBucket: "ling-dev-123.appspot.com",
	messagingSenderId: "589705404153"
};

// var config = {
//     apiKey: "AIzaSyDrD_bc_gv1tWfFhdRQwsDDdGAvZ3jFA10",
//     authDomain: "ling-156609.firebaseapp.com",
//     databaseURL: "https://ling-156609.firebaseio.com",
//     projectId: "ling-156609",
//     storageBucket: "ling-156609.appspot.com",
//     messagingSenderId: "1070890490518"
// }


firebase.initializeApp(config);
const settings = {timestampsInSnapshots: true};
firebase.firestore().settings(settings)
export default firebase;



// WEBPACK FOOTER //
// ./src/Configs/firebase.js